import { BaseClient } from 'src/common-services/clients/base-client'
import { UserWithMeta } from 'src/common-services/types/user-types'
import {
  SubscriptionRequest,
  SubscriptionResponse,
  ProductsWithPrices,
  ConfirmPaymentRequest,
  UpdatedSubscriptionResponse,
  PreviewProrationRequest,
  PreviewProrationResponse,
  CancelledSubscriptionResponse,
} from 'src/types/payments'

export class PaymentsClient extends BaseClient {
  getProducts = (): Promise<ProductsWithPrices> => {
    return this.call<ProductsWithPrices>('/payments/plans', 'GET')
  }

  createSubscription = (request: SubscriptionRequest): Promise<SubscriptionResponse> => {
    return this.call<SubscriptionResponse>('/payments/create-subscription', 'POST', {
      data: request,
    })
  }

  createSubscriptionWithTrial = (request: SubscriptionRequest) => {
    return this.call<boolean>('/payments/create-subscription-optional-trial', 'POST', {
      data: request,
    })
  }

  confirmPayment = (request: ConfirmPaymentRequest): Promise<UserWithMeta> => {
    return this.call<UserWithMeta>('/payments/confirm', 'POST', {
      data: request,
    })
  }

  previewProration = (request: PreviewProrationRequest): Promise<PreviewProrationResponse> => {
    return this.call<PreviewProrationResponse>('/payments/preview-proration', 'POST', {
      data: request,
    })
  }

  updateSubscription = (request: SubscriptionRequest): Promise<UpdatedSubscriptionResponse> => {
    return this.call<UpdatedSubscriptionResponse>('/payments/update-subscription', 'POST', {
      data: request,
    })
  }

  cancelSubscription = (): Promise<CancelledSubscriptionResponse> => {
    return this.call<CancelledSubscriptionResponse>('/payments/cancel-subscription', 'POST')
  }

  getTrialedStatus = (): Promise<boolean> => {
    return this.call<boolean>('/payments/trialed-status', 'GET')
  }
}
